export type OnboardingEmergencyContactsState = {
  primaryName: string;
  primaryAddress: string;
  primaryPhone: string;
  primaryRelationship: string;
  secondaryName: string;
  secondaryAddress: string;
  secondaryPhone: string;
  secondaryRelationship: string;
};

export type OnboardingEmergencyContactsAction =
  | { type: "SET_PRIMARY_NAME"; payload: string }
  | { type: "SET_PRIMARY_ADDRESS"; payload: string }
  | { type: "SET_PRIMARY_PHONE"; payload: string }
  | { type: "SET_PRIMARY_RELATIONSHIP"; payload: string }
  | { type: "SET_SECONDARY_NAME"; payload: string }
  | { type: "SET_SECONDARY_ADDRESS"; payload: string }
  | { type: "SET_SECONDARY_PHONE"; payload: string }
  | { type: "SET_SECONDARY_RELATIONSHIP"; payload: string }
  | { type: "SET_ALL"; payload: Partial<OnboardingEmergencyContactsState> };

export const onboardingEmergencyContactsInitialState: OnboardingEmergencyContactsState = {
  primaryName: "",
  primaryAddress: "",
  primaryPhone: "",
  primaryRelationship: "",
  secondaryName: "",
  secondaryAddress: "",
  secondaryPhone: "",
  secondaryRelationship: "",
};

export function onboardingEmergencyContactsReducer(state: OnboardingEmergencyContactsState, action: OnboardingEmergencyContactsAction): OnboardingEmergencyContactsState {
  switch (action.type) {
    case "SET_PRIMARY_NAME":
      return { ...state, primaryName: action.payload };
    case "SET_PRIMARY_ADDRESS":
      return { ...state, primaryAddress: action.payload };
    case "SET_PRIMARY_PHONE":
      return { ...state, primaryPhone: action.payload };
    case "SET_PRIMARY_RELATIONSHIP":
      return { ...state, primaryRelationship: action.payload };
    case "SET_SECONDARY_NAME":
      return { ...state, secondaryName: action.payload };
    case "SET_SECONDARY_ADDRESS":
      return { ...state, secondaryAddress: action.payload };
    case "SET_SECONDARY_PHONE":
      return { ...state, secondaryPhone: action.payload };
    case "SET_SECONDARY_RELATIONSHIP":
      return { ...state, secondaryRelationship: action.payload };
    case "SET_ALL":
      return { ...state, ...action.payload };
    default:
      console.log(`Error - incorrect action sent ${JSON.stringify(action)} ${JSON.stringify(state)}`);
      return state;
  }
}
